export function omit<T, K extends [keyof T, ...(keyof T)[]]>(obj: T, keys: K): Omit<T, K[number]> {
  const copied = { ...obj };
  keys.forEach((key) => {
    delete copied[key];
  });
  return copied as Omit<T, K[number]>;
}
